import React from 'react'
import { Link } from 'gatsby'
import styled from 'styled-components'
import { OutboundLink } from 'gatsby-plugin-google-analytics'

import { media } from 'src/utils/style-helper'

// H1. 128/128pt
export const H1 = styled.h1`
  font-family: ${(props) => props.theme.fonts.athletics.medium};
  color: inherit;
  margin: 0;
  padding: 0;
  line-height: 1;
  ${media.mobile`
    font-size: 64px;
  `}
  ${media.tablet`
    font-size: 88px;
  `}
  ${media.desktop`
    font-size: 133px;
  `}
`

// H3/Home headline. 64/64pt
export const Headline = styled(H1)`
  color: inherit;
  ${media.mobile`
    font-size: 36px;
  `}
  ${media.tablet`
    font-size: 40px;
  `}
  ${media.desktop`
    font-size: 64px;
  `}
`

// H4/Footer Nav. 52/64pt
export const H4 = styled.h4`
  font-family: ${(props) => props.theme.fonts.athletics.medium};
  color: inherit;
  margin: 0;
  padding: 0;
  ${media.mobile`
    font-size: 36px;
    line-height: 44px;
  `}
  ${media.tablet`
    font-size: 40px;
    line-height: 50px;
  `}
  ${media.desktop`
    font-size: 52px;
    line-height: 60px;
  `}
`

// H5/Consultation Main Copy
export const H5 = styled.h5`
  font-family: ${(props) => props.theme.fonts.athletics.medium};
  color: inherit;
  margin: 0;
  padding: 0;
  ${media.mobile`
    font-size: 40px;
    line-height: 46px;
  `}
  ${media.desktop`
    font-size: 52px;
    line-height: 60px;
  `}
`

// Quote/Dek Style/Product Names. 36/46pt
export const H6 = styled.p`
  font-family: ${(props) => props.theme.fonts.athletics.medium};
  color: inherit;
  margin: 0;
  padding: 0;
  ${media.mobile`
    font-size: 28px;
    line-height: 36px;
  `}
  ${media.tablet`
    font-size: 30px;
    line-height: 36px;
  `}
  ${media.desktop`
    font-size: 36px;
    line-height: 44px;
  `}
`

//  Big Article Titles
export const Title = styled.h1`
  font-family: ${(props) => props.theme.fonts.larsseit.regular};
  color: inherit;
  margin: 0;
  padding: 0;
  font-size: 36px;
  line-height: 46px;
`

//  Large Body. 24/36pt
export const LargeP = styled.p`
  font-family: ${(props) => props.theme.fonts.larsseit.regular};
  color: inherit;
  margin: 0;
  padding: 0;
  ${media.mobile`
    font-size: 18px;
    line-height: 30px;
  `}
  ${media.desktop`
    font-size: 24px;
    line-height: 36px;
  `}
`

//  Medium Body. 18/28pt
export const P = styled(LargeP)`
  color: inherit;
  margin: 0;
  padding: 0;
  ${media.mobile`
    font-size: 18px;
    line-height: 28px;
  `}
  ${media.tablet`
    font-size: 18px;
    line-height: 22px;
  `}
  ${media.desktop`
    font-size: 18px;
    line-height: 30px;
  `}
`

//  Small text. 14/23pt
export const SmallP = styled(LargeP)`
  color: inherit;
  ${media.mobile`
    font-size: 12px;
    line-height: 18px;
  `}
  ${media.tablet`
    font-size: 12px;
    line-height: 18px;
  `}
  ${media.desktop`
    font-size: 14px;
    line-height: 23px;
  `}
`

export const Error = styled(SmallP)`
  color: ${(props) => props.theme.colors.warning};
  height: 30px;
`

// Small Technical Detail. 13/13pt
export const MonoP = styled.p`
  font-family: ${(props) => props.theme.fonts.monosten.normal};
  text-transform: uppercase;
  color: inherit;
  margin: 0;
  padding: 0;
  font-size: 13px;
  line-height: 1;
  letter-spacing: 0.5px;
`

const StyledAniLink = styled(Link)`
  text-decoration: none;
  color: inherit;
  transition: 100ms all ease-in-out;
  &:hover {
    color: ${(props) => props.theme.colors.orange};
  }
`

export const ALink = styled(OutboundLink)`
  text-decoration: none;
  color: inherit;
  transition: 100ms all ease-in-out;
  &:hover {
    color: ${(props) => props.theme.colors.orange};
  }
`

export const ExternalLink = ({ to, children, name, className }) => {
  return name ? (
    <ALink href={to} target="_blank" rel="noreferrer noopener" aria-label={name} className={className}>
      {children}
    </ALink>
  ) : (
    <ALink href={to} target="_blank" rel="noreferrer noopener" className={className}>
      {children}
    </ALink>
  )
}

export const InternalLink = ({ to, children, state, className }) => {
  return (
    <StyledAniLink to={to} state={state} className={className}>
      {children}
    </StyledAniLink>
  )
}
